// use default because of HOCs applied
export { default as Page } from '../../templates/components/StandardPage/Page';
export * from './components/Savebar';
export * from './components/Banner';
export * from './components/Titlebar';
export * from './context/PageScroll.context';

export { default } from '../../templates/components/StandardPage/Page';
